import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {convertHexToRGB} from "@material-ui/core/styles/colorManipulator";
import Colors from "./CustomColors";
import {MoreVert, ArrowBack} from "@material-ui/icons/";
import {Editor} from "react-draft-wysiwyg";
import EditorState from "draft-js/lib/EditorState";
import {convertFromRaw} from "draft-js";
import * as Utility from "../components/Utility";

import {
    Button, AppBar, MenuItem, FormControlLabel, Typography, CardContent, Card, CardActions, Avatar, CardHeader, List,
    ListItem, Divider, MuiThemeProvider, SvgIcon, Checkbox, IconButton, Menu, Grow, Tabs, Tab, Paper,
    createMuiTheme
} from "@material-ui/core/index";

const styles = ({
    card: {
        display: "flex",
        flexFlow: "column nowrap",
        height: "100%",
        width: "100%",
    },
    title: {
        marginBottom: 16,
        fontSize: 14,
    },
    cardContent: {
        padding: 0,
        paddingBottom: 0,
        flex: 1,
        overflow: "auto",
    },
    button: {
        width: "100%",
        marginLeft: 24,
        marginRight: 24,
    },
    actions: {
        paddingLeft: 24,
    },
    listItem: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    tabContainer: {
        paddingLeft: 10,
    },
    tabs: {
        flexGrow: 1,
        width: "100%",
    },
    backButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    customScrollButtons: {
        color: "rgba(0, 0, 0, 0.54)",
    },
    messengerDescription: {
        wordWrap: "break-word",
    },
    textContainer: {
        padding: 24,
    },
    distributionButton: {
        width: "100%",
        marginTop: 10,
    },
    messengerButton: {
        width: "100%",
        marginLeft: 24,
        marginRight: 24,
    },
});

function MessengerIcon(props) {
    switch (props.messengerIndex) {
        case 0: // WhatsApp
            return (
                <SvgIcon style={{width: 18, height: 18, padding: "0 0 1 0"}}>
                    <svg viewBox="0 0 448 512">
                        <path
                            d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                    </svg>
                </SvgIcon>
            );
        case 1: // Facebook Messenger
            return (
                <SvgIcon style={{width: 18, height: 18, padding: "0 0 1 0"}}>
                    <svg viewBox="0 0 448 512">
                        <path
                            d="M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z"/>
                    </svg>
                </SvgIcon>
            );
        case 2: // Telegram
            return (
                <SvgIcon style={{width: 18, height: 18, padding: "0 0 1 0"}}>
                    <svg viewBox="30 35 200 200">
                        <path
                            d="m 155.91221,156.28613 c 3.82213,-10.4461 17.81729,-50.17266 20.06432,-60.591798 2.54062,-11.780443 -2.77796,-12.930544 -14.87454,-8.979356 -12.09657,3.951189 -43.11909,15.449414 -48.34049,17.302714 -5.2214,1.8533 -30.641435,10.39687 -35.911664,12.9461 -10.764524,5.77386 -5.528019,14.58535 6.505791,19.16062 35.967683,17.26467 25.754703,8.46685 41.812423,40.41274 3.30464,8.16089 11.09674,22.06171 18.5597,11.55404 3.92326,-5.97624 9.17875,-23.5903 12.18446,-31.80506 z"/>
                    </svg>
                </SvgIcon>
            );
        case 3: // Notify
            return (
                <SvgIcon style={{width: 18, height: 18, padding: "1 0 0 0"}}>
                    <svg viewBox="0 0 1400 1400">
                        <path
                            d="M416.748,1140.6l-149.562,0c-137.576,0 -249.27,-111.694 -249.27,-249.27l0,-498.539c0,-137.575 111.694,-249.269 249.27,-249.27l152.634,0l125.51,251.021c7.755,15.51 25.157,23.653 42.034,19.669c16.877,-3.985 28.8,-19.05 28.8,-36.391l0,-234.299l118.178,0c-1.073,9.152 -1.625,18.462 -1.625,27.9c0,130.993 106.349,237.342 237.341,237.342c15.362,0 30.385,-1.462 44.937,-4.256l0,486.823c0,137.576 -111.693,249.269 -249.27,249.27l-152.633,0l-125.511,-251.02c-7.755,-15.51 -25.156,-23.653 -42.033,-19.669c-16.877,3.984 -28.8,19.049 -28.8,36.39l0,234.299Z"/>
                        <circle cx="970.058" cy="171.423" r="162.025" fill="#fff"/>
                    </svg>
                </SvgIcon>
            );
        case 4: // Viber
            return (
                <SvgIcon style={{width: 18, height: 18, padding: "0 0 1 0"}}>
                    <svg>
                        <path d="M12.892 13.745s.427.038.656-.247l.448-.563c.216-.28.738-.458 1.249-.174.676.382 1.55.982 2.149 1.541.33.278.407.688.182 1.121l-.002.009c-.232.408-.541.791-.932 1.148l-.009.006c-.44.367-.946.58-1.487.404l-.01-.014c-.972-.275-3.304-1.464-4.79-2.649-2.431-1.918-4.159-5.082-4.637-6.778l-.015-.01c-.176-.543.039-1.049.404-1.488l.007-.008c.357-.391.739-.701 1.148-.932l.009-.002c.432-.225.842-.149 1.121.182.367.379 1.056 1.291 1.54 2.149.284.51.106 1.033-.173 1.248l-.564.448c-.284.23-.247.657-.247.657s.834 3.156 3.953 3.952zm4.907-2.616c-.167 0-.303-.135-.304-.302-.014-1.83-.564-3.288-1.634-4.332-1.072-1.045-2.427-1.581-4.027-1.592-.168-.001-.303-.138-.301-.306.001-.167.136-.301.303-.301h.002c1.762.012 3.258.606 4.447 1.764 1.19 1.162 1.802 2.765 1.817 4.763.001.167-.133.304-.301.306h-.002zm-1.595-.624h-.007c-.168-.004-.301-.143-.297-.31.024-1.038-.273-1.878-.906-2.569-.63-.689-1.495-1.065-2.645-1.149-.167-.013-.293-.158-.281-.325.013-.167.158-.293.325-.281 1.294.095 2.32.548 3.049 1.345.733.8 1.092 1.807 1.065 2.992-.004.165-.139.297-.303.297zm-1.558-.522c-.161 0-.295-.126-.303-.289-.051-1.03-.537-1.534-1.527-1.588-.168-.009-.296-.152-.287-.319.009-.168.151-.296.319-.287 1.308.07 2.034.819 2.101 2.164.009.167-.12.31-.288.318l-.015.001zm6.817 3.469c-.605 4.877-4.172 5.185-4.83 5.396-.28.09-2.882.737-6.152.524 0 0-2.438 2.94-3.199 3.705-.119.119-.258.167-.352.145-.131-.032-.167-.188-.165-.414l.02-4.016v-.001c-4.762-1.323-4.485-6.295-4.431-8.898.054-2.603.543-4.736 1.996-6.17 2.61-2.364 7.987-2.011 7.987-2.011 4.541.02 6.717 1.387 7.222 1.845 1.675 1.434 2.528 4.867 1.904 9.895zm-.652-11.113c-.597-.548-3.007-2.298-8.375-2.322 0 0-6.33-.382-9.416 2.45-1.718 1.718-2.322 4.231-2.386 7.348-.063 3.118-.146 8.958 5.484 10.542l.006.002-.004 2.416s-.035.979.609 1.179c.779.241 1.236-.502 1.981-1.304.408-.44.971-1.086 1.397-1.58 3.851.322 6.812-.417 7.149-.526.777-.253 5.177-.816 5.893-6.657.738-6.022-.358-9.83-2.338-11.548z"/>
                    </svg>
                </SvgIcon>
            );
        case 5: // Insta
            return (
                <SvgIcon style={{width: 18, height: 18, padding: "2 0 0 0"}}>
                    <svg viewBox="0 0 448 512">
                        <path
                            d="M197.656 3.250 C 144.882 5.020,95.365 28.002,60.942 66.703 C 60.302 67.422,59.627 68.179,59.441 68.385 C 59.078 68.788,56.925 71.313,55.765 72.697 C 29.359 104.212,14.053 144.004,11.957 186.595 C 10.187 222.542,19.545 260.356,37.950 291.633 C 38.541 292.639,39.087 293.567,39.163 293.696 C 39.300 293.931,35.118 306.442,6.012 392.875 C 5.292 395.015,4.709 396.770,4.718 396.775 C 4.727 396.781,6.105 396.344,7.781 395.804 C 9.456 395.264,33.329 387.617,60.832 378.809 L 110.837 362.796 112.625 363.761 C 143.847 380.597,178.996 388.353,214.811 386.310 C 309.837 380.889,386.833 305.741,394.608 210.827 C 395.179 203.863,395.410 191.555,395.077 185.845 C 394.123 169.474,392.022 156.576,388.012 142.487 C 363.959 57.975,285.132 0.316,197.656 3.250 M208.952 33.749 C 291.006 36.709,358.101 100.808,364.281 182.142 C 364.630 186.733,364.672 187.793,364.724 193.216 C 365.648 289.105,283.444 364.556,188.001 355.422 C 162.806 353.010,137.811 344.379,116.944 330.885 C 116.067 330.318,115.224 329.780,115.069 329.690 L 114.788 329.525 83.853 339.437 C 66.839 344.889,52.905 349.318,52.890 349.280 C 52.874 349.241,57.377 335.783,62.897 319.372 C 68.416 302.961,72.932 289.505,72.932 289.469 C 72.932 289.434,72.485 288.778,71.938 288.011 C 35.488 236.905,32.382 168.361,64.054 114.038 C 94.077 62.545,149.891 31.617,208.952 33.749 M131.052 112.513 C 117.054 123.752,105.607 132.996,105.613 133.055 C 105.624 133.145,158.885 245.899,159.214 246.527 C 159.325 246.739,160.188 246.053,188.145 223.537 C 203.995 210.772,216.985 200.330,217.012 200.333 C 217.039 200.335,232.775 218.791,251.980 241.345 C 271.186 263.900,286.908 282.322,286.918 282.283 C 286.942 282.193,249.878 120.107,249.820 120.049 C 249.796 120.025,235.392 131.135,217.811 144.738 C 200.230 158.341,185.816 169.443,185.781 169.409 C 185.747 169.374,179.152 151.966,171.127 130.724 C 163.101 109.482,156.528 92.097,156.519 92.090 C 156.511 92.083,145.050 101.273,131.052 112.513"/>
                    </svg>
                </SvgIcon>
            );
        default:
            console.warn("Wrong messenger index!");
            return;
    }
}

function ContentContainer(props) {
    return (
        <Typography component="div" style={{padding: 24}}>
            {props.children}
        </Typography>
    );
}

class Widget extends React.Component {

    /* ------ LIFECYCLE -------- */

    constructor(props) {
        super(props);

        this.state = {
            messengerSelected: 0,
            buttonsEnabled: true,
            anchorElement: null,
            primaryColor: "#000000",

            currentPhoneNumber: "+" + Utility.getRandomPhoneNumber(props.phoneNumbers),
            checkboxChecked: !props.config.checkbox.visible,
            isMessengerSelected: props.config.appearance.tabs,
            numberDistribution: props.config.messenger[0].numberDistribution,
        };
    };

    componentWillReceiveProps = () => {
        if (!this.props.config.checkbox.visible) {
            this.setState({checkboxChecked: !this.props.config.checkbox.visible});
        }
        this.setState({
            numberDistribution: this.props.config.messenger[this.state.messengerSelected].numberDistribution,
        });
    };

    /* ------ UTILITY -------- */

    getEditorState = () => {
        let currentMessenger = this.props.config.messenger[this.state.messengerSelected];
        let editorIndex = currentMessenger.numberDistribution;
        if (Utility.isUserMobileOrTablet() && currentMessenger.numberDistribution === 1 && currentMessenger.descriptions.length !== 2) {
            editorIndex = 2;
        }

        // Neat little hack to efficiently deep clone an object
        let rawContentCopy = JSON.parse(JSON.stringify(currentMessenger.descriptions[editorIndex]));

        if (!rawContentCopy["entityMap"]) {
            rawContentCopy["entityMap"] = {};
        }

        let numberBlock = rawContentCopy.blocks.find(blocks => (blocks.text.indexOf("%number%")) !== -1);
        if (numberBlock) {
            let index = numberBlock.text.indexOf("%number%");
            if (index !== -1) {
                numberBlock.text = numberBlock.text.replace("%number%", this.state.currentPhoneNumber);
                if (numberBlock) {
                    numberBlock.entityRanges = [];
                }
                numberBlock.inlineStyleRanges.push({
                    offset: index,
                    length: this.state.currentPhoneNumber.length,
                    style: "BOLD"
                });
            }
        }

        let numberDistributionStartMessage;
        if (this.props.referral) {
            numberDistributionStartMessage = this.props.messengerData.referral[this.props.referral];
        } else {
            numberDistributionStartMessage = this.props.config.messenger[this.state.messengerSelected].numberDistributionStartMessages[editorIndex];
        }

        let startBlock = rawContentCopy.blocks.find(blocks => (blocks.text.indexOf("%start%")) !== -1);
        if (startBlock) {
            let index = startBlock.text.indexOf("%start%");
            if (index !== -1) {
                startBlock.text = startBlock.text.replace("%start%", numberDistributionStartMessage);
                if (numberBlock) {
                    numberBlock.entityRanges = [];
                }
                startBlock.inlineStyleRanges.push({
                    offset: index,
                    length: numberDistributionStartMessage.length,
                    style: "BOLD"
                });
            }
        }

        let facebookBlock = rawContentCopy.blocks.find(blocks => (blocks.text.indexOf("%facebook%")) !== -1);
        if (facebookBlock) {
            let index = facebookBlock.text.indexOf("%facebook%");
            if (index !== -1) {
                let facebookUser = this.props.messengerData.facebook_user;
                facebookBlock.text = facebookBlock.text.replace("%facebook%", facebookUser);
                facebookBlock.inlineStyleRanges.push({
                    offset: index,
                    length: facebookUser.length,
                    style: "BOLD"
                });
            }
        }

        let telegramBlock = rawContentCopy.blocks.find(blocks => (blocks.text.indexOf("%telegram%")) !== -1);
        if (telegramBlock) {
            let index = telegramBlock.text.indexOf("%telegram%");
            if (index !== -1) {
                let telegramUser = this.props.messengerData.telegram_user;
                telegramBlock.text = telegramBlock.text.replace("%telegram%", telegramUser);
                telegramBlock.inlineStyleRanges.push({
                    offset: index,
                    length: telegramUser.length,
                    style: "BOLD"
                });
            }
        }

        return EditorState.createWithContent(convertFromRaw(rawContentCopy));
    };

    /* ------ HANDLER -------- */

    handleMessengerButtonClick = id => {
        const index = this.props.config.messenger.indexOf(this.props.config.messenger.find(messenger => messenger.id === id));

        this.setState({
            messengerSelected: index,
            isMessengerSelected: true
        }, () => {
            if (!this.props.config.checkbox.visible && this.state.messengerSelected === 0 && this.state.numberDistribution === 1) {
                this.handleDistributionButtonClick();
            }
        });
    };

    handleDistributionButtonClick = () => {
        let facebookUser = this.props.messengerData.facebook_user;
        let telegramUser = this.props.messengerData.telegram_user;
        let instaChannelId = this.props.messengerData.cid;

        let link = "";

        let numberDistributionStartMessage;
        if (this.props.referral) {
            numberDistributionStartMessage = this.props.messengerData.referral[this.props.referral];
        } else {
            let numberDistribution = this.state.numberDistribution;

            if (Utility.isUserMobileOrTablet()) {
                numberDistribution += 1;
            }

            numberDistributionStartMessage = this.props.config.messenger[this.state.messengerSelected].numberDistributionStartMessages[numberDistribution];
        }

        switch (this.props.config.messenger[this.state.messengerSelected].id) {
            case 0: // WhatsApp
                switch (this.state.numberDistribution) {
                    case 0: // Link number directly
                        link = "tel:" + this.state.currentPhoneNumber;
                        break;
                    case 1: // WhatsApp-Link
                        link = "https://" + (Utility.isUserIE(navigator) || Utility.isUserMobileOrTablet() ? "api" : "web") + ".whatsapp.com/send";
                        link += "?phone=" + this.state.currentPhoneNumber.substr(1, this.state.currentPhoneNumber.length - 1);
                        link += "&text=" + encodeURIComponent(numberDistributionStartMessage);
                        break;
                    case 3: // Download as vCard
                        link = "https://widget.messengerpeople.com/widget_more/" + this.props.widgetHash +
                            "/?get=vcard&nr=" + this.state.currentPhoneNumber.split("+")[1];
                        break;
                    default:
                        link = "#";
                        console.warn("No distribution link defined!");
                        break;
                }
                break;
            case 1: // Facebook Messenger
                link = "https://www.m.me/" + facebookUser;
                break;
            case 2: // Telegram
                link = "https://telegram.me/" + telegramUser;
                break;
            case 3: // Insta
                link = "https://notify.messengerpeople.com/applink/" + instaChannelId + "/open";
                break;
            case 4: { // Viber
                link = "https://app.messengerpeople.com/forward?id=VI&widget=" + this.props.widgetHash;

                // Kaufland Slovakia: 15493
                if (this.props.messengerData.cid === "15493") {
                    const language = "sk";
                    const prefix = "421";
                    const banner = "https://media.kaufland.com/images/content/messenger/kaufland-logo-mp-v2.png";
                    link += `&language=${language}&prefix=${prefix}&banner=${banner}`;
                }

                break;
            }
            default:
                console.warn("Wrong messenger index!");
                break;
        }

        window.open(link);
    };

    handleTabChange = (event, value) => {
        this.setState({
            messengerSelected: value,
            primaryColor: this.props.config.messenger[value].color
        });
    };

    handleBackButtonClick = () => {
        this.setState({isMessengerSelected: false});
    };

    handleCheckboxChange = name => event => {
        this.setState({[name]: event.target.checked});
    };

    handleMenuClose = () => {
        this.setState({anchorElement: null});
    };

    handleMenuClick = event => {
        this.setState({anchorElement: event.currentTarget});
    };

    handleMenuItemClick = url => () => {
        // Idk why but we need that event thingy ¯\_(ツ)_/¯
        window.open(Utility.getValidLink(url));
        this.handleMenuClose();
    };

    /* ------ HTML -------- */

    getDistributionButton() {
        const {classes} = this.props;
        let buttonText = this.props.config.messenger[this.state.messengerSelected]
            .distributionButtonTexts[this.props.config.messenger[this.state.messengerSelected].numberDistribution]
            .replace("%number%", this.state.currentPhoneNumber);

        if (this.props.config.messenger[this.state.messengerSelected].distributionButtonTexts.length > 0) {
            return (
                <MuiThemeProvider theme={createMuiTheme({
                    palette: {
                        primary: {
                            main: this.props.config.messenger[this.state.messengerSelected].color,
                            contrastText: this.props.config.messenger[this.state.messengerSelected]
                                .textColor,
                        },
                        secondary: {
                            main: this.props.config.messenger[this.state.messengerSelected].textColor,
                        }
                    }
                })}>
                    <Button
                        variant="raised"
                        color="primary"
                        className={classes.distributionButton}
                        onClick={this.handleDistributionButtonClick}
                    >
                        {buttonText}
                    </Button>
                </MuiThemeProvider>
            )
        }
    };

    getCardHeader() {
        const {classes} = this.props;

        return (
            <CardHeader
                className={classes.header}
                avatar={
                    <div>
                        {this.props.config.appearance.tabs || !this.state.isMessengerSelected ? (
                            <Avatar src={this.props.messengerData.picture} className={classes.avatar}/>
                        ) : (
                            <IconButton
                                className={classes.backButton}
                                color="primary"
                                aria-label="Back"
                                onClick={this.handleBackButtonClick}
                            >
                                <ArrowBack/>
                            </IconButton>
                        )}
                    </div>
                }
                title={(this.props.config.appearance.tabs || !this.state.isMessengerSelected) ? (
                    <div style={{color: this.props.config.appearance.textColor, opacity: 0.87}}>
                        {this.props.config.content.heading}
                    </div>
                ) : (
                    <Typography variant="title" color="primary">
                        {this.props.config.messenger[this.state.messengerSelected].name}
                    </Typography>
                )}
                subheader={(this.props.config.appearance.tabs || !this.state.isMessengerSelected) &&
                <div style={{color: this.props.config.appearance.textColor, opacity: 0.54}}>
                    {this.props.config.content.subHeading.replace("%channel%", this.props.messengerData.channelname)}
                </div>
                }
                action={
                    <div>
                        <IconButton
                            aria-owns={this.state.anchorElement ? "more-menu" : null}
                            aria-haspopup="true"
                            onClick={this.handleMenuClick}
                            style={{color: this.props.config.appearance.textColor, opacity: 0.54}}
                        >
                            <MoreVert/>
                        </IconButton>
                        <Menu
                            id="more-menu"
                            anchorEl={this.state.anchorElement}
                            open={Boolean(this.state.anchorElement)}
                            onClose={this.handleMenuClose}
                            TransitionComponent={Grow}
                            MenuListProps={{style: {backgroundColor: this.props.config.appearance.backgroundColor}}}
                        >
                            {this.props.config.menuItems.map(element => (
                                <MenuItem
                                    key={element.id}
                                    onClick={this.handleMenuItemClick(element.url)}
                                    style={{color: this.props.config.appearance.textColor}}
                                >
                                    {element.name}
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                }
                style={{
                    color: this.props.config.appearance.textColor,
                    backgroundColor: this.props.config.appearance.backgroundColor
                }}
            />
        );
    };

    getCardTabs() {
        const {classes} = this.props;

        return (
            <AppBar
                position="static"
                elevation={0}
                style={{backgroundColor: this.props.config.appearance.backgroundColor}}
            >
                {this.props.config.appearance.tabs &&
                <div className={classes.tabs}>
                    <Tabs
                        value={this.state.messengerSelected}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        scrollable
                        scrollButtons="auto"
                        fullWidth
                        style={{
                            color: convertHexToRGB(this.props.config.appearance.textColor).split(")")[0] + ",0.54)",
                        }}
                    >
                        {Utility.getEnabledMessenger(this.props.config, this.props.messengerData).map((element, index) => {
                            if (element.visible) {
                                return (
                                    <Tab
                                        key={element.id}
                                        value={index}
                                        label={<span style={{
                                            fontSize: 11,
                                            color: this.state.messengerSelected === index ? "" :
                                                convertHexToRGB(this.props.config.appearance.textColor)
                                                    .split(")")[0] + ",0.54)"
                                        }}>
                                            {element.name}</span>}
                                        icon={
                                            <div style={{
                                                color: this.state.messengerSelected === index ? "" :
                                                    convertHexToRGB(this.props.config.appearance.textColor)
                                                        .split(")")[0] + ",0.54)"
                                            }}>
                                                <MessengerIcon
                                                    path={element.path}
                                                    className={classes.icon}
                                                    viewBox={element.viewbox}
                                                    messengerIndex={element.id}
                                                />
                                            </div>
                                        }
                                    />
                                );
                            } else {
                                return false;
                            }
                        })}
                    </Tabs>
                </div>
                }
            </AppBar>
        );
    };

    getCardContent() {
        const {classes} = this.props;

        return (
            <CardContent
                className={classes.cardContent}
                style={{backgroundColor: this.props.config.appearance.backgroundColor}}
            >
                {this.props.config.appearance.tabs || this.state.isMessengerSelected ? (
                    <ContentContainer>
                        {this.state.checkboxChecked ? (
                            <div>
                                <Typography component="div" style={{color: this.props.config.appearance.textColor}}>
                                    <Editor readOnly={true} toolbarHidden={true} editorState={this.getEditorState()}/>
                                </Typography>
                                {this.getDistributionButton()}
                            </div>
                        ) : (
                            this.props.config.checkbox.notCheckedText.match(new RegExp("[%]\\S+[%]")) !== null ? (
                                <Typography
                                    className={classes.messengerDescription}
                                    component="p"
                                    style={{
                                        color: this.props.config.appearance.textColor,
                                        textAlign: "center"
                                    }}
                                >
                                    {this.props.config.checkbox.notCheckedText.split(new RegExp("[%]\\S+[%]"))[0]}
                                    <a
                                        href={Utility.getValidLink(this.props.config.privacy.statementUrl)}
                                        target="_blank"
                                    >
                                        {this.props.config.checkbox.notCheckedText.match(new RegExp("[%]\\S+[%]"))[0]
                                            .replace("%", "").replace("%", "")}
                                    </a>
                                    {this.props.config.checkbox.notCheckedText.split(new RegExp("[%]\\S+[%]"))[1]}
                                </Typography>
                            ) : (
                                <Typography
                                    component="p"
                                    style={{
                                        color: this.props.config.appearance.textColor,
                                        textAlign: "center"
                                    }}
                                >
                                    {this.props.config.checkbox.notCheckedText}
                                </Typography>
                            )
                        )}
                    </ContentContainer>
                ) : (
                    <List component="ul">
                        {Utility.getEnabledMessenger(this.props.config, this.props.messengerData).map(element => {
                            if (element.visible) {
                                return (
                                    <ListItem className={classes.listItem} key={element.id}>
                                        <MuiThemeProvider theme={createMuiTheme({
                                            palette: {
                                                primary: {
                                                    main: element.color,
                                                    contrastText: element.textColor,
                                                },
                                                secondary: {
                                                    main: element.textColor,
                                                }
                                            }
                                        })}>
                                            <Button
                                                className={classes.messengerButton}
                                                variant="raised"
                                                color="primary"
                                                onClick={(e) => this.handleMessengerButtonClick(element.id, e)}
                                            >
                                                <MessengerIcon
                                                    messengerIndex={element.id}
                                                    color="secondary"
                                                />
                                                <span style={{marginLeft: 4}}>{element.name}</span>
                                            </Button>
                                        </MuiThemeProvider>
                                    </ListItem>
                                );
                            } else {
                                return false;
                            }
                        })}
                    </List>
                )}
            </CardContent>
        );
    };

    getCardActions() {
        const {classes} = this.props;

        return (
            <CardActions className={classes.actions}>
                <FormControlLabel control={
                    <Checkbox
                        checked={this.state.checkboxChecked}
                        onChange={this.handleCheckboxChange("checkboxChecked")}
                        value="checkboxChecked"
                        style={{
                            color: this.state.checkboxChecked ?
                                this.props.config.messenger[this.state.messengerSelected].color :
                                convertHexToRGB(this.props.config.appearance.textColor).split(")")[0] + ",0.54)"
                        }}
                    >
                    </Checkbox>
                } label={(this.props.config.checkbox.text.match(new RegExp("[%]", "g"))) !== null ? (
                    <Typography component="p" style={{color: this.props.config.appearance.textColor}}>
                        {this.props.config.checkbox.text.split("%")[0]}
                        <a
                            style={{color: this.props.config.appearance.textColor}}
                            href={Utility.getValidLink(this.props.config.privacy.statementUrl)}
                            target="_blank"
                        >
                            {this.props.config.checkbox.text.split("%")[1]}
                        </a>
                        {this.props.config.checkbox.text.split("%")[2]}
                    </Typography>
                ) : (
                    <Typography component="p" style={{color: this.props.config.appearance.textColor}}>
                        {this.props.config.checkbox.text}
                    </Typography>
                )}/>
            </CardActions>
        );
    };

    getCardFooter() {
        let tabsVisible = this.props.config.appearance.tabs;
        if (tabsVisible || (this.state.isMessengerSelected && this.props.config.checkbox.visible)) {
            return (
                <div style={{backgroundColor: this.props.config.appearance.backgroundColor}}>
                    <Divider/>
                    {this.getCardActions()}
                </div>
            );
        }
    };

    getCompanyText() {
        const {classes} = this.props;

        if (this.props.config.appearance.companyText) {
            return (
                <div className={classes.textContainer}>
                    <Typography component="p" style={{color: this.props.config.appearance.textColor, whiteSpace: "pre-wrap"}}>
                        {this.props.config.content.companyText}
                    </Typography>
                </div>
            );
        }
    };

    getWidget() {
        const {classes} = this.props;

        return (
            <Card
                className={classes.card}
                elevation={this.props.config.appearance.border ? 1 : 0}
            >
                <Paper
                    elevation={this.props.config.appearance.border ? 1 : 0}
                    style={{backgroundColor: this.props.config.appearance.backgroundColor, zIndex: 2}}>
                    {this.getCardHeader()}
                    {this.props.config.appearance.companyText && <Divider/>}
                    {this.getCompanyText()}
                    {this.props.config.appearance.tabs && <Divider/>}
                    {this.getCardTabs()}
                </Paper>
                {this.getCardContent()}
                <div/>
                {/* Just to remove bottom padding of CardContent. I have no clue why, but it works :D */}
                {this.getCardFooter()}
            </Card>
        );
    };

    /* ------ RENDER -------- */

    render() {
        const theme = createMuiTheme({
            palette: {
                primary: {
                    main: this.props.config.messenger[this.state.messengerSelected].color,
                    contrastText: "#000000",
                },
                secondary: {
                    main: Colors.lightText,
                }
            },
        });

        return (
            <MuiThemeProvider theme={theme}>
                {this.getWidget()}
            </MuiThemeProvider>
        )
    }
}

ContentContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

Widget.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Widget);



// WEBPACK FOOTER //
// ./src/components/Widget.js